(async function () {
    const datadogRum = (window as any)['DD_RUM'];
    const htmx = (await import('./htmx-1.9.12')).default;
    Object.assign(window as any, {
        datadogRum,
        htmx
    });
})();
